
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Pripni',
	'find_label': 'Najdi',
	'findCancelLabel': 'Prekliči',
	'sourcePaneLabel': 'Izbrani izvori',
	'sourcePaneContentLabel': 'Izberi izvor',
	'addDataDashboardCoachMarkContents': 'Povlecite in spustite podatke iz podokna s podatki v vašo delovno tablo.',
	'addDataStoryCoachMarkContents': 'Povlecite in spustite podatke iz podokna s podatki v zgodbo.',
	'addDataCoachMarkTitle': 'Dodaj podatke',
	'selectSourcesText': 'Izberite in dodajte izvor podatkov, da zgradite %{app}.',
	'selectSourcesLabel': 'Izberi izvor',
	'errorSourcesTitle': 'Nalaganje podatkovnega drevesa ni uspelo',
	'errorLoadingDataSources': 'Med nalaganjem seznama naborov podatkov je prišlo do napake',
	'errorLoadingDataTree': 'Med nalaganjem drevesa je prišlo do napake',
	'dataSetPaneLastUpdated': 'Zadnja posodobitev: %{date}',
	'dataSourcePaneDateUnknown': 'Neznano',
	'moreTitle': 'Dodatne možnosti',
	'backLabel': 'Pojdi nazaj',
	'addDataSourceDialogTitle': 'Dodaj izvor podatkov',
	'addDataSourceDialogButtonLabel': 'Dodaj',
	'dlg_use': 'Uporabi',
	'dlg_RelinkDataSourceTitle': 'Zamenjaj nabor podatkov \'%{dataSourceName}\' s/z ...',
	'propertiesDialogTitle': 'Lastnosti',
	'missingDataSetData': 'Podatki za ta nabor podatkov niso na voljo. Osvežite nabor podatkov ali pa se za dostop do izvora obrnite na skrbnika.',
	'errorLoadingSource': 'Metapodatki za \'%{sourceName}\' se niso naložili. Prosimo, da se za podrobnosti obrnete na skrbnika.',
	'errorMessageTitle': 'Napaka',
	'calculation_navigation_in_use': 'Brisanje izračunov ali navigacijskih poti razveljavi vse vizualizacije, ki se sklicujejo na izbrisano postavko. Ali ste prepričani, da želite izbrisati?',
	'delete_confirm': 'Potrdi brisanje',
	'previewUnavailable': 'Podatkovni pladenj in globalni filtri niso na voljo za ta tip paketa.',
	'contextualGridTabName': 'Podatki vizualizacije',
	'DATA_TRAY_no_data_text': '\'Podatki bodo prikazani tukaj.\'',
	'contextualGridMenuLabel': 'Meni podatkov vizualizacije',
	'contextualGridExport': 'Izvozi',
	'nullValueText': 'Ničelno',
	'forecastDetailsTabName': 'Napovedovanje statističnih podrobnosti',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Mere natančnosti',
	'forecastDetailsSmoothingCoefLabel': 'Parametri',
	'forecastDetailsDiagnostics': 'Diagnosticiranje',
	'forecastDetailsForecastLabel': 'Napoved',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Natančnost %',
	'forecastDetailsTrendLabel': 'Trendni',
	'forecastDetailsSeasonLabel': 'Sezonskost',
	'forecastDetailsSeasonalPeriodLabel': 'Sezonsko obdobje',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gama',
	'forecastDetailsPhiLabel': 'Fi',
	'forecastDetailsMissingCount': 'Manjka števec',
	'forecastDetailsSeriesLengthLabel': 'Dolžina serije',
	'forecastDetailsIgnoredPeriods': 'Prezrta obdobja',
	'forecastDetailsTrendStrength': 'Moč trenda',
	'forecastDetailsSeasonalityStrength': 'Moč sezonskosti',
	'forecastDetailsTimeDeltaUnit': 'Datumski/časovni interval',
	'forecastDetailsNotes': 'Opombe'
});
